import { getArray, get, post, put, removeList } from '../index'

export default {
  list: (params) => getArray('products', params),
  get: (id) => get(`products/${id}`),
  create: (product) => post('products', product),
  update: (id, product) => put(`products/${id}`, product),
  remove: (array) => removeList('products/{id}', array)
}
